import {IconButton} from "@mui/material";
import {BugReport, BugReportOutlined, List, ListAltOutlined, VolumeOff, VolumeUp} from "@mui/icons-material";
import React from "react";
import {connect} from "react-redux";
import {selectProject} from "../../../redux/selectors/editor";
import {selectUser} from "../../../redux/selectors/firebase";

export interface GameToolsProps {
    muted: boolean
    onSetMuted: (muted: boolean) => void
    onSetShowRegisters: (value: boolean) => void
    onSetShowDebug: (value: boolean) => void
    showDebug: boolean
    showRegisters: boolean
}
interface GameToolsRedux {
    project: string
    user: any
}
function GameTools({muted, onSetMuted, onSetShowDebug, onSetShowRegisters, showDebug, showRegisters, project, user}:
                       GameToolsProps & GameToolsRedux) {
    const editor = user.roles.editor || user.roles[project]?.editor;
    const handleClickShowRegisters = () => {
        onSetShowRegisters(! showRegisters);
    }
    const handleClickShowDebug = () => {
        onSetShowDebug(! showDebug);
    }
    const handleMutedClick = () => onSetMuted(!muted);
    const registerTitle = `Show register values: Currently ${showRegisters ? "on" : "off"}`;
    const debugTitle = `Enable debug tools: Currently ${showDebug ? "on" : "off"}`;
    const muteTitle = `Toggle mute sound (Currently ${muted ? "muted" : "unmuted"})`

    return <>
        <IconButton
            color="inherit"
            data-mode="write"
            title={muteTitle}
            onClick={handleMutedClick}
            size="large">
            {muted ? <VolumeOff /> : <VolumeUp />}
        </IconButton>
        <IconButton
            disabled={!editor}
            color="inherit"
            onClick={handleClickShowRegisters}
            title={registerTitle}
            size="large">
            {showRegisters ? <List/> : <ListAltOutlined/>}
        </IconButton>
        <IconButton
            disabled={!editor}
            color="inherit"
            onClick={handleClickShowDebug}
            title={debugTitle}
            size="large">
            {showDebug ? <BugReport/> : <BugReportOutlined/>}
        </IconButton>
    </>;
}
const mapStateToProps = (store: never) => ({
    project: selectProject(store),
    user: selectUser(store),
});

export default connect(mapStateToProps, {
})(GameTools);
